import React, {ChangeEvent, useRef} from "react";
import {Icon, styled, theme} from "@reside/ui";

type Props = Readonly<{
  value: string;
  onChange: (value: string) => void;
}>;

export const PermissionsManagementSearchField = ({value, onChange}: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <SearchWrapper>
      <IconWrapper>
        <Icon name="search" color={theme.color.gray100} size={13} />
      </IconWrapper>
      <SearchInput
        ref={inputRef}
        type="text"
        placeholder="Search by name or email...."
        value={value}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          onChange(event.target.value);
        }}
      />
      {value.length > 0 && (
        <ClearButton
          aria-label="Clear search"
          type="button"
          onClick={() => {
            onChange("");

            if (inputRef.current) {
              inputRef.current.focus();
            }
          }}
        >
          <Icon name="clear" color={theme.color.gray100} size={13} />
        </ClearButton>
      )}
    </SearchWrapper>
  );
};

const SearchWrapper = styled.div`
  max-width: 420px;
  position: relative;
  width: 30%;
  margin-top: 24px;
`;

const IconWrapper = styled.div`
  left: 12px;
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;

const SearchInput = styled.input`
  background-color: ${theme.color.white};
  border: 1px solid ${theme.color.darkBlue10};
  border-radius: 100px;
  box-sizing: border-box;
  color: ${theme.color.darkBlue100};
  font-family: Gilroy, sans-serif;
  font-size: 14px;
  font-weight: 500;
  height: 32px;
  padding: 0 32px 0 32px;
  width: 100%;

  &:focus {
    border-color: ${theme.color.primary};
    outline: none;
  }

  &::placeholder {
    color: ${theme.color.gray100};
  }
`;

const ClearButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
`;
